<template>
<v-navigation-drawer
  v-model="isNavigationDrawerOpened"
  app
  fixed
    class="contrast"
  >
    <v-list class="pa-1">
      <v-list-tile avatar>
        <v-list-tile-avatar>
          <img :src="getGravatarUrl(user.email, 100)" alt="gravatar">
        </v-list-tile-avatar>

        <v-list-tile-content>
          <v-list-tile-title>{{ user.username }}</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>

    <v-list class="pt-0" >
      <v-divider></v-divider>

      <v-list-tile>
        <v-list-tile-action>
          <v-icon>search</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>

        <div class="search-bar">
          <v-text-field
            placeholder="Full Search"
            v-model="searchText"
            @keypress.enter="search"
            ></v-text-field>
        </div>
        </v-list-tile-content>
      </v-list-tile>

      <v-divider></v-divider>

      <v-list-tile :to="{ name: 'Home' }">
        <v-list-tile-action>
          <v-icon left>home</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>Home</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>

      <v-list-tile :to="{ name: 'Buckets', query: { type: 'Enterprise' } }">
        <v-list-tile-action>
          <v-icon left>money</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>Enterprise Buckets</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>

      <v-list-tile :to="{ name: 'PayingBuckets' }">
        <v-list-tile-action>
          <v-icon left>money</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>Paying Buckets</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>


      <v-list-tile :to="{ name: 'Users' }">
        <v-list-tile-action>
          <v-icon left>person</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>User List</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>

      <v-divider></v-divider>

      <v-list-group prepend-icon="receipt">
        <v-list-tile slot="activator">
          <v-list-tile-title>Purchase orders</v-list-tile-title>
        </v-list-tile>

        <v-list-tile :to="{ name: 'List purchase orders' }">
          <v-list-tile-content>
            <v-list-tile-title>List purchase orders</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-list-tile :to="{ name: 'Create purchase order' }">
          <v-list-tile-content>
            <v-list-tile-title>Create a purchase order</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

      </v-list-group>

      <v-list-tile :to="{ name: 'Trial' }">
        <v-list-tile-avatar>
          <v-icon left>history</v-icon>
        </v-list-tile-avatar>

        <v-list-tile-content>
          <v-list-tile-title>Trial creation</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>

      <v-divider></v-divider>

      <!-- <v-list-tile :to="{ name: 'Changelog' }"> -->
      <!--   <v-list-tile-avatar> -->
      <!--     <v-icon left>newspaper</v-icon> -->
      <!--   </v-list-tile-avatar> -->

      <!--   <v-list-tile-content> -->
      <!--     <v-list-tile-title>Changelog</v-list-tile-title> -->
      <!--   </v-list-tile-content> -->
      <!-- </v-list-tile> -->

      <!-- <v-list-tile :to="{ name: 'PM2 downloads' }"> -->
      <!--   <v-list-tile-action> -->
      <!--     <v-icon left>cloud_download</v-icon> -->
      <!--   </v-list-tile-action> -->

      <!--   <v-list-tile-content> -->
      <!--     <v-list-tile-title>PM2 Downloads</v-list-tile-title> -->
      <!--   </v-list-tile-content> -->
      <!-- </v-list-tile> -->
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import getGravatarUrl from '../../utils/avatar'
import { SET_NAVIGATION_DRAWER } from '../../store/mutations'

export default {
  data: () =>  ({
    searchText: '',
  }),
  computed: {
    user () {
      return this.$store.getters.user
    },
    isNavigationDrawerOpened: {
      get () {
        return this.$store.getters.isNavigationDrawerOpened || !this.$vuetify.breakpoint.mdAndDown
      },
      set (val) {
        this.$store.commit(SET_NAVIGATION_DRAWER, val)
      }
    }
  },
  methods: {
    search () {
      this.$router.push({ name: 'Results', params: { searchText: this.searchText.trim() } })
    },
    getGravatarUrl
  }
}
</script>

<style lang="postcss" scoped>
.search-bar {
  display: flex;
  align-items: center;
}
</style>
